// extracted by mini-css-extract-plugin
export default {"box":"CircleResult_box__DGIPY","progress":"CircleResult_progress__FtHKk","progress-background":"CircleResult_progress-background__FITyo","text":"CircleResult_text__u120+"};